<script setup lang="ts">
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';
import { type SearchMode } from '@utils/types';
import { ReserveType } from '@utils/itinerary';

useCheckLandingContent();
const contentStore = useContentStore();
const flightForm = useFlightForm();
const { setReserveType } = useSearchFormStore();
const route = useRoute();
const destination = route.params.code.toString();
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: `https://mrbilit.com${route.path.replace(/\/$/, '')}`,
        },
    ],
});

const { landingPageContents, landingCityName } = classToRefs(contentStore);

definePageMeta({
    validate: ({ path }) => /\/flights\/(\w{3}|\w+-airlines)/.test(path),
});
onMounted(async () => {
    flightForm.searchMode =
        (landingPageContents.value?.mode as SearchMode) || 'domestic';
    await flightForm.loadLandingSearchParams(destination);
    setReserveType(ReserveType.Flight);
});
definePageMeta({
    breadcrumbs: JSON.stringify([
        { title: 'مِستربلیط', link: '/' },
        { title: 'بلیط هواپیما', link: '/plane-ticket' },
        {
            title: 'بلیط هواپیما خارجی',
            link: '/international-flights',
            foreign: true,
        },
        { title: 'بلیط هواپیما $cityName', link: '$routePath' },
    ]),
});
</script>
<template>
    <InformationContainer
        :title="`راهنمای خرید اینترنتی پرواز ${landingCityName} از مِستربلیط `"
    />
</template>
